"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToggle = void 0;
const react_1 = require("react");
function useToggle(defaultValue = false) {
    const [isToggled, toggle] = (0, react_1.useState)(defaultValue);
    return { isToggled, toggle };
}
exports.useToggle = useToggle;
//# sourceMappingURL=useToggle.js.map